var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fullscreen-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.492 3.586a1.5 1.5 0 0 1-1.34 1.644c-1.24.127-2.428.285-3.374.425a1.322 1.322 0 0 0-1.123 1.123c-.158 1.07-.34 2.45-.473 3.862a1.5 1.5 0 0 1-2.987-.28c.14-1.482.33-2.916.491-4.019a4.322 4.322 0 0 1 3.655-3.655c.976-.143 2.21-.308 3.507-.44a1.5 1.5 0 0 1 1.644 1.34Zm5.016 0a1.5 1.5 0 0 1 1.644-1.34c1.297.132 2.53.297 3.507.44a4.322 4.322 0 0 1 3.655 3.655 78.66 78.66 0 0 1 .49 4.02 1.5 1.5 0 1 1-2.986.279 75.564 75.564 0 0 0-.473-3.862 1.322 1.322 0 0 0-1.123-1.123 78.012 78.012 0 0 0-3.374-.425 1.5 1.5 0 0 1-1.34-1.644ZM3.628 17.009a1.5 1.5 0 0 1 1.654 1.328c.116 1.061.252 2.064.373 2.885a1.322 1.322 0 0 0 1.123 1.123c.946.14 2.134.299 3.374.425a1.5 1.5 0 1 1-.304 2.985 80.991 80.991 0 0 1-3.507-.441 4.322 4.322 0 0 1-3.655-3.655 83.173 83.173 0 0 1-.386-2.995 1.5 1.5 0 0 1 1.327-1.655Zm20.745 0a1.5 1.5 0 0 1 1.327 1.655 83.132 83.132 0 0 1-.386 2.995 4.322 4.322 0 0 1-3.655 3.655 80.99 80.99 0 0 1-3.507.44 1.5 1.5 0 0 1-.304-2.984 77.988 77.988 0 0 0 3.374-.425 1.322 1.322 0 0 0 1.123-1.123c.121-.82.257-1.824.373-2.886a1.5 1.5 0 0 1 1.655-1.327Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fullscreen-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.d822ee10.svg";
export { ForwardRef as ReactComponent };